
<template>
    <div>
        <v-card>
            <v-alert class="mt-12" color="primary" dark border="left">
            GYM VIRTUAL DE INTELIGENIO
            </v-alert>
        </v-card>
        <v-btn color="error" class="ma-2 white--text" @click="goBack">
      <v-icon left>
        mdi-arrow-left
      </v-icon>
      Volver
    </v-btn>
        <v-row class="gap-3 d-flex mt-15">
            <router-link 
                v-for="(level, index) in filteredEducationalLevels" 
                :key="index" 
                :to="{ name: 'gymVirtualVista', params: { level: level.title} }"
                class="router-link ml-5"
            >
            <v-card width="250" class="my-card rounded-lg elevation-10">
                <img :src="level.resources[0].iframeSrc" height="300" width="100%" alt="">
                <v-card-title class="d-flex justify-center py-2" >{{level.title}} </v-card-title>
            </v-card>
        </router-link>
        </v-row>
    </div>
</template>

<script>
// import axios from '../../../helpers/axios'
import {mapState} from 'vuex';


export default {
    
    components:{
//         estudianteData() {

// // Intenta obtener los datos de la ruta, si no hay, utiliza localStorage
// let data = this.$route.params.estudianteData;
// if (!data || data.level == undefined) {
// // Intenta leer desde localStorage
// const storedData = localStorage.getItem('gymvirtualParams');

//     if (storedData) {
//         data = JSON.parse(storedData);
//     }
// }

// return { level: this.$route.params.level, estudianteData: data };
// },
    },
    
    data: () => ({
    educationalLevels : [
    {
        title: 'Rutina 01',
        nivel: 'Primaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/1.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
            
        ]
    },
    {
        title: 'Rutina 02',
        nivel:'Primaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/1.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 03',
         nivel:'Primaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/1.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 04',
         nivel:'Primaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/1.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 05',
         nivel:'Primaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/1.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 06',
        nivel:'Primaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/1.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 07',
        nivel:'Primaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/1.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 08',
        nivel:'Primaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/1.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 09',
        nivel:'Primaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/1.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 10',
        nivel:'Primaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/1.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 11',
        nivel:'Primaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/1.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 12',
        nivel:'Primaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/1.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 1',
        nivel:'Secundaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/2.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 2',
        nivel:'Secundaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/2.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 3',
        nivel:'Secundaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/2.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 4',
        nivel:'Secundaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/2.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 5',
        nivel:'Secundaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/2.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 6',
        nivel:'Secundaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/2.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 7',
        nivel:'Secundaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/2.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    {
        title: 'Rutina 8',
        nivel:'Secundaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/2.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
    ],
    estudianteResponse:[],
    
    
    }),


    mounted() {
          
    },
computed: {
    ...mapState('globals', ['id_colegio', 'id_usuario']),
    //Creando Propiedad Computada para recibir el Param del padre con el Vuex
    nivelSeleccionado() {
        return this.$route.params.nivel;
    },
    
    //funcion para filtrar por compentents 
    filteredEducationalLevels() {
        return this.educationalLevels.filter(level => level.nivel === this.nivelSeleccionado);
    },
  },

  methods: {
    goBack() {
      this.$router.push({ name: 'gymvirtual' });
    },
    getEstudianteData() {
      let data = { level: this.$route.params.level, estudianteData: this.$route.params.estudianteData };
      return data;
    },
  },
};
</script>

<style scoped>
.my-card{
    transition: transform 0.3s ease;
    cursor: pointer;
    margin-top: 20px;
    margin-bottom: 20px; 
}

.my-card:hover{
    transform: scale(1.05);
}

.router-link{
    text-decoration: none;
}
.v-row {
    margin-bottom: 30px;
}
</style>